var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"coursera-collection"},[_c('h2',[_vm._v(_vm._s(_vm.collection.title))]),_c('div',{staticClass:"carousel"},[_c('CourseraCarousel',{attrs:{"courses":_vm.courses},on:{"open-course":_vm.emitOpenCourse}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }